import {
  SectionedHorizontalLinedTable,
  SwitchAppButton,
} from "../../components";
import { SectionedHeader } from "../../components/SectionedHorizontalLinedTable/SectionedHeader";
import { LeftRightSection } from "../../components/SectionedHorizontalLinedTable/LeftRightSection";
import { CheckboxLRSection } from "../../components/SectionedHorizontalLinedTable/LeftRightSection/CheckboxLRSection";
import { ActivationRequiredWarning } from "../../components";
import {
  IHookForm,
  ISubscriptionAndEmailSettings,
} from "../../interfaces-and-types";
import { HookFormCheckbox, SubmitButton } from "../../hook-form";

export const View = ({
  goBack,
  isDirty,
  handleSubmit,
  errors,
  register,
}: IHookForm<ISubscriptionAndEmailSettings> & {
  goBack: () => void;
  isDirty: boolean;
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <ActivationRequiredWarning
        title="Please you need to activate your profile"
        subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
        urlTarget="/onboarding"
      />

      <SectionedHorizontalLinedTable>
        <SectionedHeader
          className="more-margin"
          hasBorder={true}
          mainHead="Manage emails & invoices sent to customers"
          subHead="Configure whether you'd like to email customers to keep their payment information up to date"
        />

        <LeftRightSection
          hasBorder={true}
          leftText="Customer emails"
          rightText={
            <div className="flex-container col gap-2">
              <HookFormCheckbox
                name="email_receipt_to_customers"
                label="Email receipt to customers"
                containerClassName="settings-checkbox"
                // infoIconText="xxxxxx"
                register={register}
                errors={errors}
              />

              <HookFormCheckbox
                name="email_receipt_to_me"
                label="Email receipt to me"
                containerClassName="settings-checkbox"
                // infoIconText="xxxxxx"
                register={register}
                errors={errors}
              />

              <HookFormCheckbox
                name="email_receipt_to_team_members"
                label="Email receipt to my team members"
                containerClassName="settings-checkbox"
                infoIconText="Team members with email access will recieve receipt emails when customers make payment"
                register={register}
                errors={errors}
              />

              {/* <HookFormCheckbox
                name="email_invoices_to_customers"
                label="Email finalized invoices to customers"
                containerClassName="settings-checkbox"
                // infoIconText="xxxxxx"
                register={register}
                errors={errors}
              />

              <HookFormCheckbox
                name="send_merchant_reminders_for_unpaid_subscriptions"
                label="Send reminder to me if a recurring invoice has not been paid"
                containerClassName="settings-checkbox"
                // infoIconText="xxxxxx"
                register={register}
                errors={errors}
              />

              <HookFormCheckbox
                name="send_customers_reminders_for_unpaid_subscriptions"
                label="Send reminder to customer if a recurring invoice has not been paid"
                containerClassName="settings-checkbox"
                // infoIconText="xxxxxx"
                register={register}
                errors={errors}
              /> */}
            </div>
          }
        />

        {/* <LeftRightSection
          hasBorder={true}
          leftText="Subscription"
          rightText={
            <div className="flex-container col gap-2">
              <div className="flex-container dropdown-container justify-content--start align-items--center row">
                Resend expired invoices
                <div className="">
                  <select {...register("resendExpiredSubscriptionInvoicesAfterDays")}>
                    <option value={30}>30 days</option>
                    <option value={15}>15 days</option>
                    <option value={7}>7 days</option>
                    <option value={3}>3 days</option>
                    <option value={2}>2 days</option>
                    <option value={1}>1 day</option>
                    <option value={0}>immediately</option>
                  </select>
                </div>
                <div> after the previous attempt</div>
              </div>
            </div>
          }
        />

        <LeftRightSection
          hasBorder={true}
          leftText="Invoice status"
          rightText={
            <div className="flex-container col gap-2">
              <div className="flex-container dropdown-container justify-content--start align-items--center row">
                Resend expired invoices
                <div className="">
                  <select {...register("resend_expired_invoices_after_days")}>
                    <option value={30}>30 days</option>
                    <option value={15}>15 days</option>
                    <option value={7}>7 days</option>
                    <option value={3}>3 days</option>
                    <option value={2}>2 days</option>
                    <option value={1}>1 day</option>
                    <option value={0}>immediately</option>
                  </select>
                </div>
                <div> after the previous attempt</div>
              </div>
            </div>
          }
        /> */}

        <SectionedHeader
          hasBorder={true}
          mainHead="Prevent failed payments"
          subHead="Configure whether you'd like to email customers to keep their payment information up to date"
        />
        <LeftRightSection
          hasBorder={true}
          leftText="Customer emails"
          rightText={
            <div className="flex-container col gap-2">
              <HookFormCheckbox
                name="send_emails_about_renewals"
                label="Send emails concerning rewewals"
                containerClassName="settings-checkbox"
                // infoIconText="xxxxxx"
                register={register}
                errors={errors}
              />

              <HookFormCheckbox
                name="send_emails_about_expiring_cards"
                label="Send emails about expiring cards"
                containerClassName="settings-checkbox"
                // infoIconText="xxxxxx"
                register={register}
                errors={errors}
              />
            </div>
          }
        />

        {/* <SectionedHeader
          className="more-margin"
          hasBorder={true}
          mainHead="Manage failed payments"
          subHead="Configure whether you'd like to email customers to keep their payment information up to date"
        />

        <LeftRightSection
          hasBorder={true}
          leftText="Retry schedule"
          rightText={
            <div className="flex-container dropdown-container justify-content--start align-items--center row">
              Retry
              <div className="">
                <select {...register("retry_failed_payments_after_days")}>
                  <option value={30}>30 days</option>
                  <option value={15}>15 days</option>
                  <option value={7}>7 days</option>
                  <option value={3}>3 days</option>
                  <option value={2}>2 days</option>
                  <option value={1}>1 day</option>
                  <option value={0}>immediately</option>
                </select>
              </div>
              <div> after the previous attempt</div>
            </div>
          }
        />

        <LeftRightSection
          hasBorder={true}
          leftText="Customer email"
          rightText={
            <div className="flex-container col gap-2">
              <HookFormCheckbox
                name="notify_customers_on_failed_payments"
                label="Notify customers on failed card payment methods or gateways"
                containerClassName="settings-checkbox"
                // infoIconText="xxxxxx"
                register={register}
                errors={errors}
              />
            </div>
          }
        />

        <LeftRightSection
          hasBorder={true}
          leftText="Subscription"
          rightText={
            <div className="flex-container col gap-2">
              <HookFormCheckbox
                name="cancel_and_notify_customer_on_failed_retries"
                label="If all retrys for a payment fails, notify customers of subscription cancellation"
                containerClassName="settings-checkbox"
                // infoIconText="xxxxxx"
                register={register}
                errors={errors}
              />
            </div>
          }
        /> */}

        <SectionedHeader
          hasBorder={true}
          mainHead="Email Security"
          subHead="Configure whether you'd like to inclue your current balance on transfer & top-up emails"
        />
        <LeftRightSection
          hasBorder={true}
          leftText="Show Current Balance"
          rightText={
            <div className="flex-container col gap-2">
              <HookFormCheckbox
                name="include_current_balance_in_emails"
                label="Show Current Balance In Emails"
                containerClassName="settings-checkbox"
                // infoIconText="xxxxxx"
                register={register}
                errors={errors}
              />

              {/* <HookFormCheckbox
                name="xxxxxxxxxxxxx"
                label="Send xxxxxxxxxxxxx"
                containerClassName="settings-checkbox"
                // infoIconText="xxxxxx"
                register={register}
                errors={errors}
              /> */}
            </div>
          }
        />

        <div className="flex-container invoice-bottom justify-content--end align-items--center">
          <div className="button-group">
            <SwitchAppButton size="sm" kind="secondary" onClick={goBack}>
              Cancel
            </SwitchAppButton>
            <SubmitButton
              size="sm"
              // disabled={!isDirty}
              showChildrenWithLoadingIcon
            >
              Save
            </SubmitButton>
          </div>
        </div>
      </SectionedHorizontalLinedTable>
    </form>
  );
};
